export default __webpack_public_path__ + "static/media/boost-sales.9ed16b49.gif";